import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { patchAddClient } from '../services/patchAddClient.service';
import {
  selectOrganizationBusinessIdToAdd,
  selectOrganizationBusinessNameToAdd,
} from '../selectors/organizationChart.selectors';

export const addProjectOrganizationChartClientNewBusiness = createAsyncThunk(
  'organizationCharts/addProjectOrganizationChartClientNewBusiness',
  async ({ targetOrganizationChartItemId }, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const businessIdToAdd = selectOrganizationBusinessIdToAdd(getState());

    const businessNameToAdd = selectOrganizationBusinessNameToAdd(getState());

    const response = await patchAddClient({
      projectId: selectedProjectId,
      targetOrganizationChartItemId,
      clientBusinessId: businessIdToAdd,
      clientBusinessName: businessNameToAdd,
      activeEmployerInfo,
    });

    return response;
  }
);
